<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Solicitudes de autorización</h2>
      </b-col>
    </b-row>

    <div class="mt-4">

      <!-- Modal Autorizar Normal -->
      <b-modal v-model="modalAutoriza" size="lg" no-close-on-backdrop>

        <b-col v-if="!cargandoRegistrosTotales">

          <p class="mt-2">
            Ingrese la fecha inicial y la fecha final de estas solicitudes respectivamente
          </p>

          <b-form-datepicker id="inicio-datepicker" v-model="fecha_inicio" class="mb-2 mt-3"></b-form-datepicker>
          <b-form-datepicker id="fin-datepicker" v-model="fecha_fin" class="mb-2"></b-form-datepicker>

          <p class="my-4" v-if="( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio <= fecha_fin )">
            Se solicitará la autorización para {{ seleccionados.length }} registros con rango de fecha entre {{ fecha_inicio }} y {{ fecha_fin }}.
            Desea continuar con el proceso de solicitud ?
          </p>
          <div v-if="( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio > fecha_fin )">
            <b-alert variant="danger" show>La fecha final es menor a la fecha inicial</b-alert>
          </div>

          <div class="mt-4" v-if=" insertRegistros.estado != null && !insertRegistros.estado">
            <!-- <b-alert class="mb-2" variant="danger" show>Error de carga</b-alert> -->
            <p>
              Se encontraron los siguientes errores
            </p>
          </div>

          <div class="mt-2" v-if=" insertRegistros.estado != null && !insertRegistros.estado && !(insertRegistros.cruces != null && insertRegistros.cruces.length > 0 ) && !( insertRegistros.alertas != null && insertRegistros.alertas.length > 0) && !(insertRegistros.limite_aforo != null && insertRegistros.limite_aforo.length > 0)">
            <b-alert variant="danger" show>Error al registrar en base de datos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.cruces != null && insertRegistros.cruces.length > 0">
            <b-alert variant="danger" show>Registros repetidos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.alertas != null && insertRegistros.alertas.length > 0">
            <b-alert variant="danger" show>Se encontraron alertas</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.limite_aforo != null && insertRegistros.limite_aforo.length > 0">
            <b-alert variant="danger" show>Limite de aforo</b-alert>
          </div>

        </b-col>
        <b-col class="text-center" v-else>
          <br><br><br><br>
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
          <br><br><br><br>
        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="warning" @click="limpiarErrores()" v-if="insertRegistros.estado != null && !insertRegistros.estado">
            Limpiar errores
          </b-button>
          <b-button variant="success" @click="solicitarAutorizacionFinal(false)" v-if="( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio <= fecha_fin ) && !cargandoRegistrosTotales">
            Solicitar ingreso
          </b-button>
          <b-button variant="info" @click="cancel()" v-if="!cargandoRegistrosTotales">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <!-- Modal Autorizar especial -->
      <b-modal v-model="modalAutorizaEspecial" size="lg" no-close-on-backdrop>

        <b-col v-if="!cargandoRegistrosTotales">

          <p class="mt-2">
            Ingrese las fecha inicial y la fecha final de estas solicitudes respectivamente
          </p>

          <b-form-datepicker id="inicio-datepicker" placeholder="Fecha de inicio" v-model="fecha_inicio" locale="es" class="mb-2 mt-3"></b-form-datepicker>
          <b-form-datepicker id="fin-datepicker" placeholder="Fecha de finalización" v-model="fecha_fin" locale="es" class="mb-2"></b-form-datepicker>

          <b-form-group label="Ingrese la hora de entrada" placeholder="Hora de entrada" label-for="input-horaIni">
            <vue-select id="input-horaIni" v-model="hora_inicio" :options="horas">
            </vue-select>
          </b-form-group>

          <b-form-group label="Ingrese la hora de salida" placeholder="Hora de salida" label-for="input-horaFin">
            <vue-select id="input-horaFin" v-model="hora_fin" :options="horas">
            </vue-select>
          </b-form-group>

          <b-form-group label="Escoja los días para los que solicita ingreso" placeholder="Día de autorización" label-for="input-dia-modal">
            <vue-select id="input-dia-modal" v-model="dias_registro" :options="diasRango" multiple>
            </vue-select>
          </b-form-group>

          <b-form-group label="Escoja el lugar para el que solicita ingreso" placeholder="Lugar de autorización" label-for="input-salon-modal">
            <vue-select id="input-salon-modal" v-model="salon_registro" :options="registrosSalones" label="NOMBRE" :reduce="registro => registro.CODIGO">
            </vue-select>
          </b-form-group>

          <b-form-group label="Motivo" placeholder="Ingrese el motivo" label-for="input-motivo-modal">
            <b-form-input id="input-motivo-modal" type="text" v-model="motivo_registro" placeholder="Ingrese el motivo"></b-form-input>
          </b-form-group>

          <p class="my-4" v-if="motivo_registro != '' && dias_registro.length > 0 && salon_registro != '' && ( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio <= fecha_fin ) && ( hora_inicio != '' && hora_fin != '' ) && ( hora_inicio <= hora_fin )">
            Se solicitará la autorización para {{ seleccionados.length }} registros con rango de fecha entre {{ fecha_inicio }} y {{ fecha_fin }} y entre las {{ hora_inicio }} y las {{ hora_fin }} los dias {{ dias_registro }}.
            Desea continuar con el proceso de solicitud ?
          </p>
          <div v-if="( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio > fecha_fin )">
            <b-alert variant="danger" show>La fecha final es menor a la fecha inicial</b-alert>
          </div>

          <div v-if="( hora_inicio != '' && hora_fin != '' ) && ( hora_inicio > hora_fin )">
            <b-alert variant="danger" show>La hora final es menor a la hora inicial</b-alert>
          </div>

          <div class="mt-4" v-if=" insertRegistros.estado != null && !insertRegistros.estado">
            <!-- <b-alert class="mb-2" variant="danger" show>Error de carga</b-alert> -->
            <p>
              Se encontraron los siguientes errores
            </p>
          </div>

          <div class="mt-2" v-if=" insertRegistros.estado != null && !insertRegistros.estado && !(insertRegistros.cruces != null && insertRegistros.cruces.length > 0 ) && !( insertRegistros.alertas != null && insertRegistros.alertas.length > 0) && !(insertRegistros.limite_aforo != null && insertRegistros.limite_aforo.length > 0)">
            <b-alert variant="danger" show>Error al registrar en base de datos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.cruces != null && insertRegistros.cruces.length > 0">
            <b-alert variant="danger" show>Registros repetidos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.alertas != null && insertRegistros.alertas.length > 0">
            <b-alert variant="danger" show>Se encontraron alertas</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.limite_aforo != null && insertRegistros.limite_aforo.length > 0">
            <b-alert variant="danger" show>Limite de aforo</b-alert>
          </div>

        </b-col>
        <b-col class="text-center" v-else>
          <br><br><br><br>
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
          <br><br><br><br>
        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="warning" @click="limpiarErrores()" v-if="insertRegistros.estado != null && !insertRegistros.estado">
            Limpiar errores
          </b-button>
          <b-button variant="success" @click="solicitarAutorizacionFinal(true)" v-if="dias_registro.length > 0 && salon_registro != '' && ( fecha_inicio != '' && fecha_fin != '' ) && ( fecha_inicio <= fecha_fin ) && ( hora_inicio != '' && hora_fin != '' ) && ( hora_inicio <= hora_fin ) && (motivo_registro != '') && !cargandoRegistrosTotales">
            Solicitar ingreso
          </b-button>
          <b-button variant="info" @click="cancel()" v-if="!cargandoRegistrosTotales">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <!-- Modal de eliminar solicitud -->
      <b-modal v-model="modalGeneradas" size="lg" no-close-on-backdrop>

        <b-col>

          <p class="my-4">
            Se eliminarán {{ seleccionados.length }} solicitudes realizadas.
            Desea continuar con el proceso de eliminación ?
          </p>

        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="danger" @click="solicitarCancelacion()">
            Eliminar solicitudes
          </b-button>
          <b-button variant="info" @click="cancel()">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <b-tabs content-class="p-3" v-model="tabActual">

        <!-- Estudiantes -->
        <b-tab title="Estudiantes" v-if="$auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_todos')">

          <b-row>
            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-est">
                <b-form-input id="input-codigo-est" type="text" v-model="filtroEstudiante.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Nombre:" label-for="input-nombre-est">
                <b-form-input id="input-nombre-est" type="text" v-model="filtroEstudiante.nombre"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Día:" label-for="input-dia-est">
                <b-form-select id="input-dia-est" v-model="filtroEstudiante.dia">
                  <b-select-option :value="''"></b-select-option>
                  <b-select-option v-for="dia in dias" :key="dia" :value="dia">{{ dia }}</b-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="NRC:" label-for="input-periodo-est">
                <div class="input-group">
                  <b-form-input id="input-periodo-est" placeholder="Periodo" type="text" v-model="filtroEstudiante.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-est" placeholder="NRC" type="text" v-model="filtroEstudiante.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2 mb-4" v-if="!cargandoEstudiantes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('ESTUDIANTE')">
                Buscar horarios
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('ESTUDIANTE')" v-if="registrosEstudiantes.length > 0">
                Solicitar autorización
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEstudiantes">

            <div v-if="registrosEstudiantes.length > 0">
              <b-table responsive striped hover :items="registrosEstudiantes" :fields="camposAutorizaciones" caption-top>

                <template #table-caption>{{registrosEstudiantes.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION)="row" class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="ESTUDIANTE"></b-form-checkbox>
                </template>

                <!-- Alertas -->
                <template #cell(ALERTAS)="row" class="d-flex justify-content-start">
                  <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.CODIGO+row.item.SALON+row.item.DIA" size="sm" variant="warning">Con alertas</b-badge>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" v-b-modal="row.item.CODIGO+row.item.SALON+row.item.DIA" variant="warning">Sin encuesta</b-badge>
                  <b-modal v-bind:id="row.item.CODIGO+row.item.SALON+row.item.DIA">
                    <div>
                      Se notificará al usuario que cuenta con alertas o que aun no ha completado la encuesta, ¿desea enviar este correo?
                    </div>
                    <br>
                    <template #modal-footer="{ cancel }">
                      <b-button v-if="!cargandoRegistrosTotales" variant="warning" @click="enviarCorreoNotificacion(
                        row.item.CODIGO+row.item.SALON+row.item.DIA,
                        row.item.CODIGO,
                        '',
                        row.item.NOMBRE,
                        row.item.ALERTAS,
          
                        )">
                        Enviar correo de notificación
                      </b-button>
                      <b-button v-if="!cargandoRegistrosTotales" variant="info" @click="cancel()">
                        Volver
                      </b-button>
                    </template>
                    <div v-if="cargandoRegistrosTotales" class="d-flex justify-content-center align-items-center">
                      <br><br>
                      <b-spinner variant="primary" label="Text Centered"></b-spinner>
                      <br><br>
                    </div>
                  </b-modal>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron horarios</b-alert>
            </div>
          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

        <!-- Docentes -->
        <b-tab title="Docentes" v-if="$auth.can('solicitar_autorizacion_profesor') || $auth.can('solicitar_autorizacion_todos')">

          <b-row>

            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-doc">
                <b-form-input id="input-codigo-doc" type="text" v-model="filtroDocente.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Nombre:" label-for="input-nombre-doc">
                <b-form-input id="input-nombre-doc" type="text" v-model="filtroDocente.nombre"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Día:" label-for="input-dia-doc">
                <b-form-select id="input-dia-doc" v-model="filtroDocente.dia">
                  <b-select-option :value="''"></b-select-option>
                  <b-select-option v-for="dia in dias" :key="dia" :value="dia">{{ dia }}</b-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="NRC:" label-for="input-periodo-doc">
                <div class="input-group">
                  <b-form-input id="input-periodo-doc" placeholder="Periodo" type="text" v-model="filtroDocente.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-doc" placeholder="NRC" type="text" v-model="filtroDocente.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoDocentes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('DOCENTE')">
                Buscar horarios
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('DOCENTE')" v-if="registrosDocentes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('DOCENTE')" v-if="registrosDocentes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('DOCENTE')" v-if="registrosDocentes.length > 0">
                Solicitar autorizacion listado
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoDocentes">

            <div v-if="registrosDocentes.length > 0">
              <b-table responsive striped hover :items="registrosDocentes" :fields="camposAutorizaciones" tabindex="1" caption-top>
                <template #table-caption>{{registrosDocentes.length + ' registros'}}</template>
                <template #cell(SELECCION)="row" class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="DOCENTE"></b-form-checkbox>
                </template>

                <!-- Alertas -->
                <template #cell(ALERTAS)="row" class="d-flex justify-content-start">
                  <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.CODIGO+row.item.SALON+row.item.DIA" size="sm" variant="warning">Con alertas</b-badge>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" v-b-modal="row.item.CODIGO+row.item.SALON+row.item.DIA" variant="warning">Sin encuesta</b-badge>
                  <b-modal v-bind:id="row.item.CODIGO+row.item.SALON+row.item.DIA">
                    <div>
                      Se notificará al usuario que cuenta con alertas o que aun no ha completado la encuesta, ¿desea enviar este correo?
                    </div>
                    <br>
                    <template #modal-footer="{ cancel }">
                      <b-button v-if="!cargandoRegistrosTotales" variant="warning" @click="enviarCorreoNotificacion(
                        row.item.CODIGO+row.item.SALON+row.item.DIA,
                        row.item.CODIGO,
                        '',
                        row.item.NOMBRE,
                        row.item.ALERTAS,
          
                        )">
                        Enviar correo de notificación
                      </b-button>
                      <b-button v-if="!cargandoRegistrosTotales" variant="info" @click="cancel()">
                        Volver
                      </b-button>
                    </template>
                    <div v-if="cargandoRegistrosTotales" class="d-flex justify-content-center align-items-center">
                      <br><br>
                      <b-spinner variant="primary" label="Text Centered"></b-spinner>
                      <br><br>
                    </div>
                  </b-modal>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron horarios</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Empleados -->
        <b-tab title="Empleados" v-if="$auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_todos')">

          <b-row>

            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-emp">
                <b-form-input id="input-codigo-emp" type="text" v-model="filtroEmpleado.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group label="Nombre:" label-for="input-nombre-emp">
                <b-form-input id="input-nombre-emp" type="text" v-model="filtroEmpleado.nombre"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoEmpleados">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('EMPLEADO')">
                Buscar empleados
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('EMPLEADO')" v-if="registrosEmpleados.length > 0">
                Solicitar autorizacion listado
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEmpleados">

            <div v-if="registrosEmpleados.length > 0">
              <b-table responsive striped hover :items="registrosEmpleados" :fields="camposEspeciales" tabindex="1" caption-top>
                <template #table-caption>{{registrosEmpleados.length + ' registros'}}</template>
                <template #cell(SELECCION)="row" class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="EMPLEADO"></b-form-checkbox>
                </template>

                <!-- Alertas -->
                <template #cell(ALERTAS)="row" class="d-flex justify-content-start">
                  <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.CODIGO" size="sm" variant="warning">Con alertas</b-badge>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" v-b-modal="row.item.CODIGO" variant="warning">Sin encuesta</b-badge>
                  <b-modal v-bind:id="row.item.CODIGO">
                    <div>
                      Se notificará al usuario que cuenta con alertas o que aun no ha completado la encuesta, ¿desea enviar este correo?
                    </div>
                    <br>
                    <template #modal-footer="{ cancel }">
                      <b-button v-if="!cargandoRegistrosTotales" variant="warning" @click="enviarCorreoNotificacion(
                        row.item.CODIGO,
                        '',
                        row.item.CORREO_INSTITUCIONAL,
                        row.item.NOMBRE_COMPLETO,
                        row.item.ALERTAS,
          
                        )">
                        Enviar correo de notificación
                      </b-button>
                      <b-button v-if="!cargandoRegistrosTotales" variant="info" @click="cancel()">
                        Volver
                      </b-button>
                    </template>
                    <div v-if="cargandoRegistrosTotales" class="d-flex justify-content-center align-items-center">
                      <br><br>
                      <b-spinner variant="primary" label="Text Centered"></b-spinner>
                      <br><br>
                    </div>
                  </b-modal>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron empleados</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Especiales -->
        <b-tab title="Especiales" v-if="$auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_todos')">

          <b-row v-if="$auth.can('solicitar_autorizacion_todos')">
            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-esp">
                <b-form-input id="input-codigo-esp" type="text" v-model="filtroEspecial.codigo"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Nombre:" label-for="input-nombre-esp">
                <b-form-input id="input-nombre-esp" type="text" v-model="filtroEspecial.nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="NRC:" label-for="input-periodo-esp">
                <div class="input-group">
                  <b-form-input id="input-periodo-esp" placeholder="Periodo" type="text" v-model="filtroEspecial.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-esp" placeholder="NRC" type="text" v-model="filtroEspecial.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoEspeciales">

            <b-col>
              <template v-if="$auth.can('solicitar_autorizacion_todos')">
                <b-button v-if="filtroEspecial.codigo != '' || filtroEspecial.nrc !='' || filtroEspecial.nombre != ''" class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('ESPECIAL')">
                  Buscar personal
                </b-button>
                <div v-else>
                  Ingrese un codigo o un nombre para buscar
                </div>

                <b-button class="mr-2" variant="info" @click="checkAll('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                  Seleccionar todo
                </b-button>

                <b-button class="mr-2" variant="info" @click="uncheckAll('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                  Deseleccionar todo
                </b-button>
              </template>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('ESPECIAL')" v-if="registrosEspeciales.length > 0">
                Solicitar autorizacion listado
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoEspeciales">

            <div v-if="registrosEspeciales.length > 0">
              <b-table responsive striped hover :items="registrosEspeciales" :fields="camposEspeciales" tabindex="1" caption-top>
                <template #table-caption>{{registrosEspeciales.length + ' registros'}}</template>
                <template #cell(SELECCION)="row" class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="ESPECIAL"></b-form-checkbox>
                </template>

                <!-- Alertas -->
                <template #cell(ALERTAS)="row" class="d-flex justify-content-start">
                  <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.CODIGO" size="sm" variant="warning">Con alertas</b-badge>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" v-b-modal="row.item.CODIGO" variant="warning">Sin encuesta</b-badge>
                  <b-modal v-bind:id="row.item.CODIGO">
                    <div v-if="$auth.can('solicitar_autorizacion_todos')">
                      Se notificará al usuario que cuenta con alertas o que aún no ha completado la encuesta, ¿desea enviar este correo?
                    </div>
                    <div v-else>
                      El sistema ha encontrado que usted cuenta con alertas o que aún no ha completado ninguna encuesta.
                    </div>
                    <br>
                    <template #modal-footer="{ cancel }" v-if="$auth.can('solicitar_autorizacion_todos')">
                      <b-button v-if="!cargandoRegistrosTotales" variant="warning" @click="enviarCorreoNotificacion(
                        row.item.CODIGO,
                        '',
                        row.item.CORREO_INSTITUCIONAL,
                        row.item.NOMBRE_COMPLETO,
                        row.item.ALERTAS,
          
                        )">
                        Enviar correo de notificación
                      </b-button>
                      <b-button v-if="!cargandoRegistrosTotales" variant="info" @click="cancel()">
                        Volver
                      </b-button>
                    </template>
                    <div v-if="cargandoRegistrosTotales" class="d-flex justify-content-center align-items-center">
                      <br><br>
                      <b-spinner variant="primary" label="Text Centered"></b-spinner>
                      <br><br>
                    </div>
                  </b-modal>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontró personal</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Visitantes -->
        <b-tab title="Visitantes" v-if="$auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_todos')">

          <b-row>

            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-vis">
                <b-form-input id="input-codigo-vis" type="text" v-model="filtroVisitante.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group label="Nombre:" label-for="input-nombre-vis">
                <b-form-input id="input-nombre-vis" type="text" v-model="filtroVisitante.nombre"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoVisitantes">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('VISITANTE')">
                Buscar visitantes
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('VISITANTE')" v-if="registrosVisitantes.length > 0">
                Solicitar autorizacion listado
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargandoVisitantes">

            <div v-if="registrosVisitantes.length > 0">
              <b-table responsive striped hover :items="registrosVisitantes" :fields="camposEspeciales" tabindex="1" caption-top>
                <template #table-caption>{{registrosVisitantes.length + ' registros'}}</template>
                <template #cell(SELECCION)="row" class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="VISITANTE"></b-form-checkbox>
                </template>

                <!-- Alertas -->
                <template #cell(ALERTAS)="row" class="d-flex justify-content-start">
                  <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.id" size="sm" variant="warning">Con alertas</b-badge>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" v-b-modal="row.item.id" variant="warning">Sin encuesta</b-badge>
                  <b-modal v-bind:id="row.item.id">
                    <div>
                      Se notificará al usuario que cuenta con alertas o que aun no ha completado la encuesta, ¿desea enviar este correo?
                    </div>
                    <br>
                    <template #modal-footer="{ cancel }">
                      <b-button v-if="!cargandoRegistrosTotales" variant="warning" @click="enviarCorreoNotificacion(
                        row.item.id,
                        '',
                        row.item.CORREO,
                        row.item.NOMBRE_COMPLETO,
                        row.item.ALERTAS,
          
                        )">
                        Enviar correo de notificación
                      </b-button>
                      <b-button v-if="!cargandoRegistrosTotales" variant="info" @click="cancel()">
                        Volver
                      </b-button>
                    </template>
                    <div v-if="cargandoRegistrosTotales" class="d-flex justify-content-center align-items-center">
                      <br><br>
                      <b-spinner variant="primary" label="Text Centered"></b-spinner>
                      <br><br>
                    </div>
                  </b-modal>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron visitantes</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>
        </b-tab>

        <!-- Solicitudes generadas -->
        <b-tab title="Solicitudes generadas" v-if="$auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_profesor') ||  $auth.can('solicitar_autorizacion_todos') ">

          <b-row>
            <b-col md="6">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-gen">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-gen" placeholder="Desde" v-model="filtroGeneradas.desde"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroGeneradas.desde" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="filtroGeneradas.hasta"></b-input>
                  <b-datepicker :initial-date="hoy" v-model="filtroGeneradas.hasta" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <b-col md="6">
              <b-form-group label="Codigo:" label-for="input-codigo-gen">
                <b-form-input id="input-codigo-gen" type="text" v-model="filtroGeneradas.codigo"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="NRC:" label-for="input-periodo-gen">
                <div class="input-group">
                  <b-form-input id="input-periodo-gen" placeholder="Periodo" type="text" v-model="filtroGeneradas.periodo" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-gen" placeholder="NRC" type="text" v-model="filtroGeneradas.nrc" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargandoGeneradas">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarDatosBusqueda('GENERADAS')">
                Buscar solicitudes
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarAutorizacion('GENERADAS')" v-if="registrosGeneradas.length > 0">
                Cancelar solicitud
              </b-button>
            </b-col>

          </b-row>

          <div v-if="!cargandoGeneradas">

            <div v-if="registrosGeneradas.length > 0">
              <b-table responsive striped hover :items="registrosGeneradas" :fields="camposSolicitudes" tabindex="1" caption-top>
                <template #table-caption>{{registrosGeneradas.length + ' registros'}}</template>
                <template #cell(NOMBRE)="row">
                  <div>{{row.item.NOMBRE}}</div>
                </template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <input type="checkbox" name="GENERADAS">
                </template>
                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron solicitudes</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

      </b-tabs>

    </div>

  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import { DateTimeFormatter, LocalDate } from '@js-joda/core'
import axios from 'axios'
import _ from 'lodash'
import { url } from '../../../services/url_service'

@Component
export default class SolicitudesAutorizacion extends Vue {

  public dias: Array<any> = [
    'LUNES',
    'MARTES',
    'MIERCOLES',
    'JUEVES',
    'VIERNES',
    'SABADO',
    'DOMINGO',
  ]

  get hoy(): string {
    return LocalDate.now().format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  public get diasRango(): Array<string> {
    if (this.fecha_inicio && this.fecha_fin) {
      console.log(this.fecha_inicio)
      console.log(this.fecha_fin)
      let inicio = LocalDate.parse(this.fecha_inicio)
      let fin = LocalDate.parse(this.fecha_fin)
      let periodo = inicio.until(fin)

      console.log(periodo.days())
      if (periodo.days() >= 7) {
        return this.dias
      } else if (inicio.isBefore(fin) || inicio.isEqual(fin)) {
        let dias = []
        while (!inicio.isAfter(fin)) {
          let dia = inicio.dayOfWeek().ordinal()
          if (!dias.includes(this.dias[dia])) {
            dias.push(this.dias[dia])
          }
          inicio = inicio.plusDays(1)
        }
        console.log(dias)
        return dias
      }
    }
    return []
  }

  public seleccionados: Array<any> = []
  public fecha_inicio: string = ""
  public fecha_fin: string = ""

  public hora_inicio: string = ""
  public hora_fin: string = ""

  public dias_registro: Array<any> = []
  public salon_registro: string = ""
  public motivo_registro: string = ""


  public dia_registro: string = ""

  public horas: Array<any> = [
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30',
  ]



  public registrosEstudiantes: Array<any> = []
  public registrosDocentes: Array<any> = []
  public registrosEmpleados: Array<any> = []
  public registrosEspeciales: Array<any> = []
  public registrosVisitantes: Array<any> = []

  public registrosGeneradas: Array<any> = []
  public registrosSalones: Array<any> = []


  public cargandoEstudiantes = false
  public cargandoDocentes = false
  public cargandoEmpleados = false
  public cargandoEspeciales = false
  public cargandoVisitantes = false

  public cargandoRegistrosTotales = false

  public cargandoGeneradas = false

  public datosGenerador: any = {}

  public page: number = 1
  public limit: number = 10
  public count: number = 0

  public filtros: any = {}
  public orden: any = {
    columna: 'fecha_inicio',
    direccion: 'ASC',
  }

  public pageErrores: number = 1
  public limitErrores: number = 10
  public countErrores: number = 0
  public errores: Array<any> = []

  public filtroEstudiante: any = {}
  public filtroDocente: any = {}
  public filtroEmpleado: any = {}
  public filtroEspecial: any = {}
  public filtroVisitante: any = {}
  public filtroGeneradas: any = {}

  public tabActual: number = 0

  // Iniciales
  public botonActivado: boolean = false
  public showOverlay: boolean = false


  // Datos de quien solicita
  public personalData: any = {}
  public persona: any = {
    codigo: '',
    rol: '',
    nombre: '',
    programa: '',
    autorizado: '',
    horario: [],
    temperatura: '',
    observaciones: '',
  }

  public insertRegistros: any = {
    estado: null,
    cruces: null,
    alertas: null,
    limite_aforo: null,
  }

  public modalAutoriza: boolean = false
  public modalAutorizaEspecial: boolean = false
  public modalGeneradas: boolean = false
  public checkNrc: boolean = null

  public camposAutorizaciones: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'ALERTAS',
      label: 'Alertas',
    },
    {
      key: 'NOMBRE',
      label: 'Nombre',
    },
    {
      key: 'CODIGO',
      label: 'Código',
    },
    {
      key: 'ROLL',
      label: 'Rol',
    },
    {
      key: 'NOMBRE_LARGO_ASIGNATURA',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'PERIODO',
      label: 'Periodo',
    },
    {
      key: 'NRC',
      label: 'NRC',
    },
    {
      key: 'CURSO',
      label: 'Curso',
    },
    {
      key: 'SALON',
      label: 'Salon',
    },
    {
      key: 'DIA',
      label: 'Dia',
    },
    {
      key: 'MATERIA',
      label: 'Materia',
    },
    {
      key: 'HORA INICIO',
      label: 'Hora Inicio',
    },
    {
      key: 'HORA FIN',
      label: 'Hora Fin',
    },

  ]


  public camposEspeciales: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'ALERTAS',
      label: 'Alertas',
    },
    {
      key: 'NOMBRE_COMPLETO',
      label: 'Nombre',
    },
    {
      key: 'CODIGO',
      label: 'Código',
    },
    {
      key: 'ROL',
      label: 'Rol',
    },
  ]

  public camposSolicitudes: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'periodo',
      label: 'Periodo',
    },
    {
      key: 'nrc',
      label: 'Nrc',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
    {
      key: 'fecha_inicio',
      label: 'Fecha de inicio',
    },
    {
      key: 'fecha_fin',
      label: 'Fecha Final',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
  ]

  @Watch('tabActual')
  public onTabChange(value, oldValue) {
    if (oldValue != value) {
      this.checkNrc = null
    }
  }

  public checkAll(registroTipo) {
    var items = document.getElementsByName(registroTipo)
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        items[i].checked = true
      }
    }
  }

  public uncheckAll(registroTipo) {
    var items = document.getElementsByName(registroTipo)
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        items[i].checked = false
      }
    }
  }

  public solicitarAutorizacion(registroTipo, autorizaTipo) {

    this.limpiarErrores()

    var registros = []
    this.seleccionados = []

    this.fecha_inicio = ""
    this.fecha_fin = ""
    this.hora_inicio = ""
    this.hora_fin = ""

    this.salon_registro = ""
    this.dias_registro = []
    this.motivo_registro = ""


    if (registroTipo == "ESTUDIANTE") {
      registros = this.registrosEstudiantes

    } else if (registroTipo == "DOCENTE") {
      registros = this.registrosDocentes

    } else if (registroTipo == "EMPLEADO") {
      registros = this.registrosEmpleados

    } else if (registroTipo == "ESPECIAL") {
      registros = this.registrosEspeciales

    } else if (registroTipo == "VISITANTE") {
      registros = this.registrosVisitantes

    } else if (registroTipo == "GENERADAS") {
      registros = this.registrosGeneradas
    }


    var items = document.getElementsByName(registroTipo)
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        if (items[i].checked == true) {

          if (registroTipo == 'GENERADAS') {
            this.modalGeneradas = true
            this.seleccionados.push(registros[i])

          } else {

            if (registroTipo == 'EMPLEADO' || registroTipo == 'ESPECIAL' || registroTipo == 'VISITANTE') {
              registros[i]['TIPO'] = registroTipo
              this.modalAutorizaEspecial = true
              this.limpiarErrores()
              this.seleccionados.push(registros[i])
            } else {
              this.modalAutoriza = true
              this.limpiarErrores()
              this.seleccionados.push(registros[i])
            }

          }

        }
      }
    }

  }

  public limpiarErrores() {
    this.insertRegistros = {
      estado: null,
      cruces: null,
      alertas: null,
      limite_aforo: null,
    }
  }


  public async enviarCorreoNotificacion(idModal, codigo, correo, nombre, alertas) {

    if (alertas.length > 0) {
      alertas = "SI"
    } else {
      alertas = "NO"
    }

    var response
    this.cargandoRegistrosTotales = true

    try {

      response = await axios.post(
        url.create('/internal/solicitudes/correo'),
        {
          "alertas": alertas,
          "nombre": nombre,
          "correo": correo,
          "codigo": codigo,
        }
      )

    } catch (error) {
      this.$bvToast.toast(
        'Sucedió un error al comunicarse con la base de datos',
        {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )

      this.cargandoRegistrosTotales = false
      return
    }

    var valido = response.data

    if (valido) {

      this.$bvModal.hide(idModal)
      this.$bvToast.toast(
        'Se ha enviado un correo notificando al usuario',
        {
          title: 'Correo enviado',
          variant: 'success',
          autoHideDelay: 5000,
        }
      )

    } else {

      this.$bvModal.hide(idModal)
      this.$bvToast.toast(
        'Error al enviar el correo, puede que este usuario no tenga un correo vinculado',
        {
          title: 'Correo no enviado',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )

    }

    this.cargandoRegistrosTotales = false




  }

  // Funcion que llama a la api para hacer la carga final de los archivos
  public async solicitarAutorizacionFinal(especial) {
    let seleccionadosFinal = []

    this.limpiarErrores()
    this.cargandoRegistrosTotales = true

    var autorizadorCompleto = this.$auth.can('solicitar_autorizacion_todos')

    if (this.datosGenerador.CODIGO == null) {
      if (autorizadorCompleto) {
        this.datosGenerador.CODIGO = "ADMIN"
      } else {

        this.cargandoRegistrosTotales = false
        this.$bvToast.toast(
          'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
          {
            title: 'Error al solicitar',
            variant: 'danger',
            autoHideDelay: 5000,
          }
        )

        this.modalAutoriza = false
        return

      }
    }

    // Si es empleado, especial o visitante se agregan los campos
    if (especial) {

      this.seleccionados.forEach(registro => {

        for (var i = 0; i < this.dias_registro.length; i++) {
          let reg = _.clone(registro)
          reg["NOMBRE_LARGO_ASIGNATURA"] = this.motivo_registro ?? ""
          reg["NOMBRE"] = registro["NOMBRE_COMPLETO"]
          reg["HORA FIN"] = this.hora_fin.toString()
          reg["HORA INICIO"] = this.hora_inicio.toString()
          reg["DIA"] = this.dias_registro[i]
          reg["FECHA_INICIO"] = this.fecha_inicio.toString()
          reg["ROLL"] = registro["ROL"]
          reg["PERIODO"] = ""
          reg["NRC"] = ""
          reg["MATERIA"] = registro["TIPO"]

          // Dividimos el lugar
          let salon = this.salon_registro.split(/-/)
          let edf = salon.shift()
          let sal = salon.join('-')

          reg["EDF"] = edf
          reg["SALON"] = sal

          seleccionadosFinal.push(reg)
        }

      })

    } else {
      seleccionadosFinal = this.seleccionados
    }

    //var arregloSeleccion = JSON.stringify(this.seleccionados)

    try {

      let response = await axios.post(
        url.create('/internal/solicitudes'),
        {
          "registros": seleccionadosFinal,
          "admin": autorizadorCompleto,
          "fechaInicio": this.fecha_inicio.toString(),
          "fechaFin": this.fecha_fin.toString(),
          "datosGenerador": this.datosGenerador,
          "tipoSolicitud": 'AUTORIZA',
        }
      )

      this.insertRegistros = response.data
      this.cargandoRegistrosTotales = false

      if (this.insertRegistros.estado) {
        this.limpiarErrores()
        this.modalAutoriza = false
        this.modalAutorizaEspecial = false
        this.$bvToast.toast(
          'Se ha realizado la solicitud de los registros seleccionados exitosamente',
          {
            title: 'Registros cargados',
            variant: 'success',
            autoHideDelay: 5000,
          }
        )

      } else { }

    } catch (error) {
      this.cargandoRegistrosTotales = false
      this.$bvToast.toast(
        'Sucedió un error al comunicarse con la base de datos',
        {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )
      return
    }


  }


  public async solicitarCancelacion() {

    this.modalGeneradas = false

    var autorizadorCompleto = (this.$auth.can('solicitar_autorizacion_estudiante') || this.$auth.can('solicitar_autorizacion_visitante') || this.$auth.can('solicitar_autorizacion_especial') || this.$auth.can('solicitar_autorizacion_empleado') || this.$auth.can('solicitar_autorizacion_profesor') || this.$auth.can('solicitar_autorizacion_todos')) ? true : false
    //var arregloSeleccion = JSON.stringify(this.seleccionados)

    if (this.datosGenerador.CODIGO == null) {
      if (autorizadorCompleto) {
        this.datosGenerador.CODIGO = "ADMIN"
      } else {

        this.cargandoRegistrosTotales = false
        this.$bvToast.toast(
          'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
          {
            title: 'Error al solicitar',
            variant: 'danger',
            autoHideDelay: 5000,
          }
        )

        this.modalAutoriza = false
        return

      }
    }

    let response = await axios.post(url.create('/internal/solicitudes/denegar'),
      {
        "registros": this.seleccionados,
        "admin": autorizadorCompleto,
        "datosGenerador": this.datosGenerador,
      }
    )

    this.insertRegistros = response.data

    if (this.insertRegistros.estado) {

      this.limpiarErrores()
      this.uncheckAll('GENERADAS')
      this.registrosGeneradas = []
      this.seleccionados = []

      this.$bvToast.toast(
        'Se han eliminado las solicitudes correctamente',
        {
          title: 'Registros eliminados',
          variant: 'success',
          autoHideDelay: 5000,
        }
      )


    } else {

      this.$bvToast.toast(
        'Error al eliminar las solicitudes',
        {
          title: 'Error al eliminar',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )

    }

  }


  // Funcion para cargar cualquier registro de cualquier tipo
  public async cargarDatosBusqueda(registroTipo) {

    let autorizadorCompleto = this.$auth.can('solicitar_autorizacion_todos')

    this.limpiarErrores()
    let registros = []

    let parametros: any = {}

    if (registroTipo == "ESTUDIANTE") {
      this.registrosEstudiantes = []
      this.cargandoEstudiantes = true
      parametros = this.filtroEstudiante

    } else if (registroTipo == "DOCENTE") {
      this.registrosDocentes = []
      this.cargandoDocentes = true
      parametros = this.filtroDocente

    } else if (registroTipo == "EMPLEADO") {
      this.registrosEmpleados = []
      this.cargandoEmpleados = true
      parametros = this.filtroEmpleado

    } else if (registroTipo == "ESPECIAL") {
      this.registrosEspeciales = []
      this.cargandoEspeciales = true
      parametros = this.filtroEspecial

    } else if (registroTipo == "VISITANTE") {
      this.registrosVisitantes = []
      this.cargandoVisitantes = true
      parametros = this.filtroVisitante

    } else if (registroTipo == "GENERADAS") {
      this.registrosGeneradas = []
      this.cargandoGeneradas = true
      parametros = this.filtroGeneradas
    }

    this.checkNrc = null
    if ((parametros.periodo && !parametros.nrc) || (parametros.nrc && !parametros.periodo)) {
      this.checkNrc = false
      this.limpiarCargando(registroTipo)
      return
    }

    try {

      if (this.datosGenerador.CODIGO == null) {
        await this.cargarGenerador()
      }

      if (this.datosGenerador.CODIGO == null) {

        if (autorizadorCompleto) {
          this.datosGenerador.CODIGO = "ADMIN"
        } else {

          this.$bvToast.toast(
            'El usuario actual no cuenta con los permisos suficientes o no se ha encontrado una identificación válida',
            {
              title: 'Error al solicitar',
              variant: 'danger',
              autoHideDelay: 5000,
            }
          )

          throw "Permisos insuficientes"

        }
      }


      var response

      parametros["admin"] = autorizadorCompleto
      parametros["codigoSolicitante"] = this.datosGenerador.CODIGO

      //if (codigoBusqueda) parametros["codigo"] = codigoBusqueda.trim()
      //if (nrcBusqueda) parametros["nrc"] = nrcBusqueda.trim()
      //if (diaBusqueda) parametros["dia"] = diaBusqueda.trim()
      //if (nombreBusqueda) parametros["nombre"] = nombreBusqueda.trim()

      if (registroTipo == "ESTUDIANTE") {
        response = await axios.get(url.create('/internal/vistas/horarios/estudiantes'), { params: parametros })
      } else if (registroTipo == "DOCENTE") {
        response = await axios.get(url.create('/internal/vistas/horarios/docentes'), { params: parametros })
      } else if (registroTipo == "EMPLEADO") {
        response = await axios.get(url.create('/internal/vistas/horarios/empleados'), { params: parametros })
      } else if (registroTipo == "ESPECIAL") {
        response = await axios.get(url.create('/internal/vistas/horarios/especiales'), { params: parametros })
      } else if (registroTipo == "VISITANTE") {
        response = await axios.get(url.create('/internal/vistas/horarios/visitantes'), { params: parametros })
      } else if (registroTipo == "GENERADAS") {
        parametros["tipoSolicitud"] = "AUTORIZA"
        response = await axios.get(url.create('/internal/solicitudes/GENERADAS'), { params: parametros })
      }

      registros = response.data

    } catch (error) {
      console.error(error)
    }


    if (registroTipo == "ESTUDIANTE") {
      this.registrosEstudiantes = registros
    } else if (registroTipo == "DOCENTE") {
      this.registrosDocentes = registros
    } else if (registroTipo == "EMPLEADO") {
      this.registrosEmpleados = registros
    } else if (registroTipo == "ESPECIAL") {
      this.registrosEspeciales = registros
    } else if (registroTipo == "VISITANTE") {
      this.registrosVisitantes = registros
    } else if (registroTipo == "GENERADAS") {
      this.registrosGeneradas = registros
    }
    this.limpiarCargando(registroTipo)

  }

  public limpiarCargando(registroTipo) {
    if (registroTipo == "ESTUDIANTE") {
      this.cargandoEstudiantes = false
    } else if (registroTipo == "DOCENTE") {
      this.cargandoDocentes = false
    } else if (registroTipo == "EMPLEADO") {
      this.cargandoEmpleados = false
    } else if (registroTipo == "ESPECIAL") {
      this.cargandoEspeciales = false
    } else if (registroTipo == "VISITANTE") {
      this.cargandoVisitantes = false
    } else if (registroTipo == "GENERADAS") {
      this.cargandoGeneradas = false
    }
  }

  public eliminarHoraFecha(fechaEntra) {
    var fechaFinalSinHora = fechaEntra.substring(0, fechaEntra.indexOf(' '))
    return fechaFinalSinHora
  }



  public async cargarSalones() {

    this.registrosSalones = []
    let response = await axios.get(url.create('/internal/salones'), {})
    //var dataFin = response.data
    //for (var i = 0; i < dataFin.length; i++) {
    //  dataFin[i]["CODIGO"] = dataFin[i].COD_EDIFICIO + "-" + dataFin[i].NUMERO_SALON
    //}

    this.registrosSalones = (response.data as Array<any>).map(function (salon) {
      return {
        'CODIGO': salon.COD_EDIFICIO + "-" + salon.NUMERO_SALON,
        'NOMBRE': salon.COD_EDIFICIO + "-" + salon.NUMERO_SALON + ": " + salon.DESCRIPCION_SALON,
      }
    })
  }

  public async cargarGenerador() {

    try {
      let responsePersonal = await axios.get(
        url.create('/internal/vistas/personal')
      )
      this.datosGenerador = await responsePersonal.data ?? {}

      if (!this.$auth.can('solicitar_autorizacion_todos')) {
        if (this.$auth.can('solicitar_autorizacion_especial')) {
          this.codigoBusquedaEsp = this.datosGenerador.CODIGO
          this.cargarDatosBusqueda('ESPECIAL')
        }
      }

    } catch (error) {
      console.log("Error al traer el registro de la vista")
      this.datosGenerador = {}
    }

  }


  @Watch('page')
  public pageChange(val) {
    this.cargarGenerador()
  }

  created() {
    this.cargarGenerador()
    this.cargarSalones()
  }

}
</script>

<style>
.tab-content {
  background-color: #ffffff;
}
</style>